/* -------------  FOOTER COMPONENT (Minimog + CW accordions) ------------- */
class MFooter extends HTMLElement {
  constructor () {
    super();
    this.init();
  }

  init () {
    /* ── acordeón propio del tema ─────────────────────────────────────── */
    const mobileAccordion = this.querySelector('.m-footer--accordion');
    if (mobileAccordion) {
      const makeAcc = () =>
        (this.acc = new MinimogLibs.Accordion(mobileAccordion, {
          presetContentHeight: true,
          onload: true,
        }));

      if (MinimogTheme.config.mqlMobile) makeAcc();
      document.addEventListener('matchMobile',  makeAcc);
    }

    /* ── altura fija de la sticky-bar móvil ───────────────────────────── */
    const mobileStickyBar = document.querySelector('.m-mobile-sticky-bar');
    if (mobileStickyBar) {
      const setBarHeight = () =>
        document.documentElement.style.setProperty(
          '--mobile-sticky-bar-height',
          `${mobileStickyBar.offsetHeight}px`,
        );
      setBarHeight();
      document.addEventListener('matchMobile',  setBarHeight);
      document.addEventListener('unmatchMobile', setBarHeight);
    }

    /* ── nuestro sub-acordeón de políticas ───────────────────────────── */
    this.initCwAccordions();
  }

  /* ------------------------ CW ACCORDION LOGIC ------------------------ */
  initCwAccordions () {
    const items = this.querySelectorAll('.cw-accordion-item');
    if (!items.length) return;

    /* recalcula la CSS var del bloque externo */
    const refreshFooterBlockHeight = (accordionItem) => {
      const block = accordionItem.closest('.m-footer--block.m-accordion--item');
      if (!block) return;

      const contentWrap = block.querySelector('.m-accordion--item-content');
      if (contentWrap)
        block.style.setProperty(
          '--content-max-height',
          contentWrap.scrollHeight + 'px',
        );
    };

    /* almacena observadores para poder desconectarlos al cerrar */
    const observers = new WeakMap();

    /* ---------- manejador de cada item ---------- */
    items.forEach((item) => {
      const btn     = item.querySelector('.cw-accordion-btn');
      const content = item.querySelector('.cw-accordion-content');

      const addResizeObserver = () => {
        if (observers.has(content)) return;            // ya existe
        const ro = new ResizeObserver(() => refreshFooterBlockHeight(item));
        ro.observe(content);
        observers.set(content, ro);
      };
      const removeResizeObserver = () => {
        const ro = observers.get(content);
        if (ro) {
          ro.disconnect();
          observers.delete(content);
        }
      };

      const openContent = () => {
        content.style.display = 'block';
        content.style.height  = content.scrollHeight + 'px';

        content.addEventListener('transitionend', function onEnd (e) {
          if (e.propertyName !== 'height') return;
          content.style.height = 'auto';
          content.removeEventListener('transitionend', onEnd);
          refreshFooterBlockHeight(item);
          addResizeObserver();            // ← empieza a vigilar cambios
        });
      };

      const closeContent = () => {
        /* desconectamos para evitar trabajos innecesarios */
        removeResizeObserver();

        content.style.height = content.scrollHeight + 'px';
        void content.offsetHeight;               // re-flow
        content.style.height = '0';

        content.addEventListener('transitionend', function onEnd (e) {
          if (e.propertyName !== 'height') return;
          content.style.display = '';            // vuelve al default
          content.removeEventListener('transitionend', onEnd);
          refreshFooterBlockHeight(item);
        });
      };

      const toggle = () => {
        const isOpen = item.classList.toggle('open');
        isOpen ? openContent() : closeContent();
      };

      btn.addEventListener('click', toggle);

      /* si llega abierto por defecto (ej. cache, server-side, etc.) */
      if (item.classList.contains('open')) {
        content.style.height  = content.scrollHeight + 'px';
        setTimeout(() => (content.style.height = 'auto'), 300);
        refreshFooterBlockHeight(item);
        addResizeObserver();
      }
    });

    /* volver a calcular todo al redimensionar / rotar */
    const recalcAll = () =>
      this.querySelectorAll('.cw-accordion-item.open')
          .forEach(refreshFooterBlockHeight);

    window.addEventListener('resize',            recalcAll);
    window.addEventListener('orientationchange', recalcAll);
  }
}

customElements.define('m-footer', MFooter);